import { usePostHttp } from "../../http.hook";

interface IResponse {
  success: boolean;
}

export function useFinaliseDmsCostAdminHttp() {
  return usePostHttp<null, IResponse>({
    path: "/admin/campaigns/:campaignId/finalise-cost",
  });
}
